<p>Kies de afdeling(en) om de medewerkers van die afdelingen in de planning te zien:</p>

<button mat-raised-button (click) = "btnOpslaan()" color="accent">Opslaan</button>